import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {IPhysiologicalDataDetails, PhysiologicalDataDetails} from '../PhysiologicalData';
import {PhysiologicalDataApi} from '../../../apis/PhysiologicalDataApi/PhysiologicalDataApi';

export function usePutPhysiologicalData() {
    const queryClient = useQueryClient();

    return useMutation<IPhysiologicalDataDetails, AppMedError, {id: string, data: IPhysiologicalDataDetails}>({
        mutationKey: [QueryKeys.physiologicalData, 'update'],
        mutationFn: async ({id, data}) => {
            const result = await PhysiologicalDataApi.putPhysiological(id, data);
            return new PhysiologicalDataDetails(result);
        },
        onSuccess: async (data: IPhysiologicalDataDetails) => {
            queryClient.setQueryData<IPhysiologicalDataDetails[]>([QueryKeys.physiologicalDataDetails], (prev) => {
                if (!prev) return [data];
                return prev.map((item) => item.id === data.id ? data : item);
            });
        },
    });
}
